

// initial state
const state = {
  assetRoot: 'https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/',

  storeMode: 'finalization', // ['creation', 'finalization'],

  appKey: 'website_mwm',
  offer: 'global_offer',
  version: '3.01.02',
  deviceType: 'web',

  env: 'prod'
}

// getters
const getters = {
  env: state => {
    return state.env
  },
  
  assetRoot: state => {
    return state.assetRoot
  },
  storeMode: state => {
    return state.storeMode
  },

  appKey: state => {
    return state.appKey
  },
  offer: state => {
    return state.offer
  },
  version: state => {
    return state.version
  },
  deviceType: state => {
    return state.deviceType
  },
}

// mutations
const mutations = {
  ['STORE_MODE_SET'] (state, storeMode) {
    state.storeMode = storeMode
  },
}

// actions
const actions = {

}

export default {
  state,
  getters,
  actions,
  mutations
}
